<style lang="scss" scoped>
.seckill-time {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  color: #ffffff;
  background: linear-gradient(270deg, #ff3155, #ff5a1f);
  font-size: 22px;
  // font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  .icon-container {
    margin-top: -18px;
    margin-right: 4px;

    width: 22px;
    height: 24px;
  }
  .clock-img {
    height: 100%;
    width: 100%;
    margin-right: 4px;
  }
}
</style>

<template>
  <div v-if="curTime > 0" class="seckill-time">
    <div class="icon-container">
      <img class="clock-img" src='./../../../assets/images/ai-picture/clock.png'/>
    </div>
    {{formatTime}}
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    secondTime: {
      default: () => {
        return 0
      }
    }
  },
  data () {
    return {
      formatTime: '',
      curTime: 0,
      index: 0,
    }
  },
  methods: {
    format (val) {
      const second = (val % 60 + '').padStart(2, '0');
      const minute = (parseInt(val / 60) % 60 + '').padStart(2, '0');
      const hour = (parseInt(val / (60 * 60)) + '').padStart(2, '0');
      // const day = (parseInt(val / (60 * 60 * 24)) + '');
      return hour + ':' + minute + ':' + second;
    }
  },
  mounted () {
    if (this.secondTime > 0) {
      this.curTime = parseInt(this.secondTime);
      const timer = setInterval(() => {
        this.curTime--;
        if (this.curTime <= 0) {
          clearInterval(timer);
          return;
        }
        this.formatTime = this.format(this.curTime);
      }, 1000);
    }
  }
}
</script>
